/**

 * Refuerzo cliente B2B: redirección en PDP bloqueada, filtro de búsqueda y limpieza de listados.

 */

(function () {

  if (document.documentElement.dataset.b2bCatalogCustomer !== 'true') return;



  var rootUrl = window.Shopify?.routes?.root_url || '/';
  var productJsonBase = window.Shopify?.routes?.root || rootUrl;
  if (!productJsonBase.endsWith('/')) productJsonBase += '/';



  if (document.querySelector('meta[name="b2b-catalog-blocked"]')) {

    window.location.replace(rootUrl);

    return;

  }



  function cleanEmptyProductSlots(scope) {

    var container = scope || document;

    container.querySelectorAll('li.column, li.columns, li.carousel__slide, .carousel__slide.columns, .columns.carousel__slide').forEach(function (el) {

      if (el.querySelector('product-card, .product-card, .product-cart-item')) return;

      if (!el.textContent.trim()) el.remove();

    });

  }



  function productHandleFromUrl(url) {

    try {

      var path = new URL(url, window.location.origin).pathname;

      var match = path.match(/\/products\/([^/?#]+)/);

      return match ? decodeURIComponent(match[1]) : null;

    } catch (e) {

      return null;

    }

  }



  function removeProductCard(link) {

    var item = link.closest('li.column, li.columns, .columns, .carousel__slide');

    if (item) {

      item.remove();

      return;

    }

    var card = link.closest('product-card, .product-card, .product-cart-item');

    if (card) card.remove();

  }



  function filterSearchResultsByCatalog() {

    var grid = document.getElementById('product-grid');

    if (!grid) return;



    var handles = {};

    grid.querySelectorAll('a[href*="/products/"]').forEach(function (link) {

      var handle = productHandleFromUrl(link.href);

      if (!handle) return;

      if (!handles[handle]) handles[handle] = [];

      handles[handle].push(link);

    });



    Object.keys(handles).forEach(function (handle) {

      fetch(productJsonBase + 'products/' + encodeURIComponent(handle) + '.js', {

        credentials: 'same-origin',

      })

        .then(function (response) {

          if (!response.ok) throw new Error('not found');

          return response.json();

        })

        .then(function (product) {

          var hasAvailableVariant = false;

          if (product.available && Array.isArray(product.variants)) {

            hasAvailableVariant = product.variants.some(function (variant) {

              return variant.available;

            });

          }

          if (!hasAvailableVariant) {

            handles[handle].forEach(removeProductCard);

            cleanEmptyProductSlots(grid);

            updateSearchCount();

          }

        })

        .catch(function () {});

    });

  }



  function updateSearchCount() {

    var grid = document.getElementById('product-grid');

    if (!grid) return;

    var count = grid.querySelectorAll('product-card, .product-card').length;

    var countEl = document.querySelector('.collection-container .facets-bar, .search-results-count, [data-search-results-count]');

    if (countEl && count === 0) {

      var empty = document.querySelector('.collection-empty');

      if (!empty) {

        var container = grid.closest('#ProductGridContainer') || grid.parentElement;

        if (container) {

          container.innerHTML =

            '<div class="collection-empty"><p>No hay productos disponibles para su catálogo B2B.</p></div>';

        }

      }

    }

  }



  cleanEmptyProductSlots();

  filterSearchResultsByCatalog();



  document.addEventListener(

    'click',

    function (event) {

      var link = event.target.closest('a[href*="/products/"]');

      if (!link) return;



      var card = link.closest('product-card, .product-cart-item, .product-card-small, .product-card');

      if (card && card.dataset.b2bCatalogAllowed === 'false') {

        event.preventDefault();

        event.stopPropagation();

      }

    },

    true

  );



  if (typeof MutationObserver !== 'undefined') {

    var pending = false;

    new MutationObserver(function () {

      if (pending) return;

      pending = true;

      requestAnimationFrame(function () {

        cleanEmptyProductSlots();

        pending = false;

      });

    }).observe(document.body, { childList: true, subtree: true });

  }

})();

